import React, { useState, useEffect } from 'react';
import { generateRandomGradient } from 'src/latest/src/utils';
import { getPicture } from 'src/redux/services/commonServices';

interface GetTherapyAddressImageProps {
  isAppointmentLocation: boolean;
  id?: string;
  officeImageUrl?: string;
}

const IconPath = '/icons/';

export const TherapyAddressImage: React.FC<GetTherapyAddressImageProps> = ({
  isAppointmentLocation,
  id,
  officeImageUrl,
}) => {
  const [image, setImage] = useState<string | undefined>();
  const [imageBackground, setImageBackground] = useState<string>('');

  const getImage = async () => {
    if (!id && !officeImageUrl) {
      setImage(undefined);
      setImageBackground(generateRandomGradient());

      return;
    }

    if (officeImageUrl) {
      const decodedUrl = decodeURIComponent(officeImageUrl);

      if (decodedUrl) {
        setImage(decodedUrl);

        return;
      }
    }

    if (id) {
      const imageData = await getPicture(id);

      setImage(imageData);
    }
  };

  useEffect(() => {
    getImage();
  }, [id, officeImageUrl]);

  return (
    <label
      className={`${
        isAppointmentLocation
          ? 'appointmentLocation-in-person-ofc-image'
          : 'practice-profile__in-person-ofc-image  therapist-profile__in-person-ofc-image'
      }`}
      style={{
        background: image ? `url(${image})` : imageBackground,
      }}
    >
      {id && id.includes('defaultofficepic.svg') ? (
        <img
          id="img"
          src={`${IconPath + 'defaultofficepic.svg'}`}
          alt="address"
          className="default-ofc-img"
        />
      ) : null}
    </label>
  );
};
